const UNICODE_WHITE_SPACE = /[\u0009-\u000D\u0020\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
const UNICODE_WHITE_SPACE_ONLY = /^[\u0009-\u000D\u0020\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]+$/;
const UNICODE_WHITE_SPACE_EDGES = /^[\u0009-\u000D\u0020\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]+|[\u0009-\u000D\u0020\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]+$/g;
const UNICODE_WHITE_SPACE_GLOBAL = /[\u0009-\u000D\u0020\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/g;

/** 按跨端约定去除首尾 Unicode White_Space 字符，不修改内部字符。 */
export function trimUnicodeWhitespace(value: string): string {
  return value.replace(UNICODE_WHITE_SPACE_EDGES, '');
}

/** 判断字符串是否包含跨端约定的 Unicode White_Space 字符。 */
export function containsUnicodeWhitespace(value: string): boolean {
  return UNICODE_WHITE_SPACE.test(value);
}

/** 判断字符串是否为空或仅由跨端约定的 Unicode White_Space 字符组成。 */
export function isUnicodeWhitespaceOnly(value: string): boolean {
  return value.length === 0 || UNICODE_WHITE_SPACE_ONLY.test(value);
}

/** 自然语言单行文本：去除首尾 Unicode 空白，并合并连续半角空格。 */
export function normalizeNaturalTextWhitespace(value: string): string {
  return trimUnicodeWhitespace(value).replace(/ {2,}/g, ' ');
}

/** 仅供明确规定“删除所有空白”的助记码等字段使用。 */
export function removeUnicodeWhitespace(value: string): string {
  return value.replace(UNICODE_WHITE_SPACE_GLOBAL, '');
}

/** 电话号码仅允许将半角空格作为分组符删除；其他内部空白仍须校验拒绝。 */
export function normalizePhoneWhitespace(value: string): string {
  return trimUnicodeWhitespace(value).replace(/ /g, '');
}
